module.exports = __webpack_public_path__ + "img/logo-prensa-02.png";